import React from 'react';
import PropTypes from 'prop-types';
import { MediaCarouselModalFullWidth } from '@dmm/lib-react-ui-components';
import { useIntl } from 'react-intl';
import { getMessages } from '../../tppServices/translations/messages';
import { detectDevice, DEVICES } from '../../tppServices/crossEnvHelpers';

const FullScreenGallery = ({ mediaItems, index, onClose, display = false }) => {
  const intl = useIntl();
  const formatMessage = intl.formatMessage;
  const messages = getMessages();
  const device = detectDevice();
  const isDesktop = device === DEVICES.desktop;
  const isMobile = device === DEVICES.mobile;
  return (
    <MediaCarouselModalFullWidth
      items={mediaItems}
      initialIndex={index}
      onClose={onClose}
      closeButtonText={formatMessage(messages.carouselModal.close)}
      open={display}
      draggable={!isDesktop}
      hideArrowButtons={isMobile}
      draggable360Image={isDesktop}
    />
  );
};

FullScreenGallery.propTypes = {
  mediaItems: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  onClose: PropTypes.func,
  display: PropTypes.bool
};

export { FullScreenGallery };
